module.exports = "app-touchspin {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 80% !important; }\n\n.btn-touchspin {\n  right: 5px;\n  position: absolute; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-individual/catalogo-obras-inversionistas-individual.component.scss
// module id = ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-individual/catalogo-obras-inversionistas-individual.component.scss
// module chunks = main